/**
 * @generated SignedSource<<c0f1f7efd9f806a6591483852863ce4d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BUDGET_TYPE = "FIXED_PRICE" | "NON_BILLABLE" | "TIME_AND_MATERIALS" | "RETAINER" | "FIXED_PRICE_V2" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type BudgetTotalsLoader_viewer$data = {
  readonly id: string;
  readonly company: {
    readonly currency: string | null;
  } | null;
  readonly project: {
    readonly budget: number | null;
    readonly rateCard: {
      readonly currency: string | null;
    } | null;
    readonly billable: boolean | null;
    readonly useBaseline: boolean | null;
    readonly budgetType: BUDGET_TYPE | null;
    readonly useFixedPriceForBaselineRevenue: boolean | null;
    readonly financialNumbers: {
      readonly plannedRevenue: number | null;
      readonly totalActualRevenueRecognition: number | null;
      readonly totalForecastRevenueToComplete: number | null;
      readonly totalRevenueRecognition: number | null;
      readonly baselineVsActualRevenueRecognition: number | null;
      readonly baselineVsTotalRevenueAtCompletion: number | null;
      readonly planVsActualRevenueRecognition: number | null;
      readonly planVsTotalRevenueAtCompletion: number | null;
      readonly baselineRevenue: number | null;
      readonly baselineVsBillableActualTimeAndExpenses: number | null;
      readonly baselineVsAllActualValueOfService: number | null;
      readonly baselineVsBillableTotalTimeAndExpensesAtCompletion: number | null;
      readonly baselineVsAllProjectedValueOfService: number | null;
      readonly billableActualTimeAndExpenses: number | null;
      readonly allActualTimeAndExpenses: number | null;
      readonly billablePlannedTimeAndExpenses: number | null;
      readonly allPlannedTimeAndExpenses: number | null;
      readonly planVsBillableActualTimeAndExpenses: number | null;
      readonly planVsTotalBillableTimeAndExpensesAtCompletion: number | null;
      readonly billableForecastTimeAndExpensesToComplete: number | null;
      readonly allForecastTimeAndExpensesToComplete: number | null;
      readonly billableTotalTimeAndExpensesAtCompletion: number | null;
      readonly allTotalTimeAndExpensesAtCompletion: number | null;
      readonly recognitionAmount: number | null;
      readonly baselineTimeAndExpenses: number | null;
      readonly baselineCost: number | null;
      readonly baselineVsActualCost: number | null;
      readonly baselineVsTotalCostAtCompletion: number | null;
      readonly actualCost: number | null;
      readonly plannedCost: number | null;
      readonly planVsActualCost: number | null;
      readonly planVsTotalCostAtCompletion: number | null;
      readonly forecastCostToComplete: number | null;
      readonly totalCostAtCompletion: number | null;
      readonly estimatedVsAllActualValueOfService: number | null;
      readonly estimatedVsAllProjectedValueOfService: number | null;
      readonly baselineProfit: number | null;
      readonly baselineVsActualProfit: number | null;
      readonly baselineVsTotalProfitAtCompletion: number | null;
      readonly actualProfit: number | null;
      readonly plannedProfit: number | null;
      readonly planVsActualProfit: number | null;
      readonly planVsTotalProfitAtCompletion: number | null;
      readonly forecastProfitToComplete: number | null;
      readonly totalProfitAtCompletion: number | null;
      readonly baselineVsActualRevenueProfit: number | null;
      readonly baselineVsTotalRevenueProfitAtCompletion: number | null;
      readonly actualRevenueProfit: number | null;
      readonly plannedRevenueProfit: number | null;
      readonly planVsActualRevenueProfit: number | null;
      readonly planVsTotalRevenueProfitAtCompletion: number | null;
      readonly forecastRevenueProfitToComplete: number | null;
      readonly totalRevenueProfitAtCompletion: number | null;
      readonly baselineMargin: number | null;
      readonly actualMargin: number | null;
      readonly plannedMargin: number | null;
      readonly forecastMarginToComplete: number | null;
      readonly totalMarginAtCompletion: number | null;
      readonly baselineVsActualRevenueMargin: number | null;
      readonly baselineVsTotalRevenueMarginAtCompletion: number | null;
      readonly planVsActualRevenueMargin: number | null;
      readonly planVsTotalRevenueMarginAtCompletion: number | null;
      readonly actualRevenueMargin: number | null;
      readonly plannedRevenueMargin: number | null;
      readonly forecastRevenueMarginToComplete: number | null;
      readonly totalRevenueMarginAtCompletion: number | null;
      readonly estimatedCost: number | null;
      readonly recognitionProfit: number | null;
      readonly recognitionProfitPercentage: number | null;
    } | null;
  } | null;
  readonly " $fragmentType": "BudgetTotalsLoader_viewer";
};
export type BudgetTotalsLoader_viewer$key = {
  readonly " $data"?: BudgetTotalsLoader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"BudgetTotalsLoader_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endDay"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endMonth"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endYear"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDay"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startMonth"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startYear"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BudgetTotalsLoader_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "internalId",
          "variableName": "projectId"
        }
      ],
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "budget",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RateCard",
          "kind": "LinkedField",
          "name": "rateCard",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "billable",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useBaseline",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "budgetType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useFixedPriceForBaselineRevenue",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "convertToProjectCurrency",
              "value": true
            },
            {
              "kind": "Variable",
              "name": "endDay",
              "variableName": "endDay"
            },
            {
              "kind": "Variable",
              "name": "endMonth",
              "variableName": "endMonth"
            },
            {
              "kind": "Variable",
              "name": "endYear",
              "variableName": "endYear"
            },
            {
              "kind": "Variable",
              "name": "startDay",
              "variableName": "startDay"
            },
            {
              "kind": "Variable",
              "name": "startMonth",
              "variableName": "startMonth"
            },
            {
              "kind": "Variable",
              "name": "startYear",
              "variableName": "startYear"
            }
          ],
          "concreteType": "FinancialNumbers",
          "kind": "LinkedField",
          "name": "financialNumbers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plannedRevenue",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalActualRevenueRecognition",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalForecastRevenueToComplete",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalRevenueRecognition",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineVsActualRevenueRecognition",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineVsTotalRevenueAtCompletion",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "planVsActualRevenueRecognition",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "planVsTotalRevenueAtCompletion",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineRevenue",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineVsBillableActualTimeAndExpenses",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineVsAllActualValueOfService",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineVsBillableTotalTimeAndExpensesAtCompletion",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineVsAllProjectedValueOfService",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "billableActualTimeAndExpenses",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allActualTimeAndExpenses",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "billablePlannedTimeAndExpenses",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allPlannedTimeAndExpenses",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "planVsBillableActualTimeAndExpenses",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "planVsTotalBillableTimeAndExpensesAtCompletion",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "billableForecastTimeAndExpensesToComplete",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allForecastTimeAndExpensesToComplete",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "billableTotalTimeAndExpensesAtCompletion",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allTotalTimeAndExpensesAtCompletion",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "recognitionAmount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineTimeAndExpenses",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineCost",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineVsActualCost",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineVsTotalCostAtCompletion",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actualCost",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plannedCost",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "planVsActualCost",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "planVsTotalCostAtCompletion",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forecastCostToComplete",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCostAtCompletion",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "estimatedVsAllActualValueOfService",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "estimatedVsAllProjectedValueOfService",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineProfit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineVsActualProfit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineVsTotalProfitAtCompletion",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actualProfit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plannedProfit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "planVsActualProfit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "planVsTotalProfitAtCompletion",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forecastProfitToComplete",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalProfitAtCompletion",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineVsActualRevenueProfit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineVsTotalRevenueProfitAtCompletion",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actualRevenueProfit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plannedRevenueProfit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "planVsActualRevenueProfit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "planVsTotalRevenueProfitAtCompletion",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forecastRevenueProfitToComplete",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalRevenueProfitAtCompletion",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineMargin",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actualMargin",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plannedMargin",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forecastMarginToComplete",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalMarginAtCompletion",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineVsActualRevenueMargin",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineVsTotalRevenueMarginAtCompletion",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "planVsActualRevenueMargin",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "planVsTotalRevenueMarginAtCompletion",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actualRevenueMargin",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plannedRevenueMargin",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forecastRevenueMarginToComplete",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalRevenueMarginAtCompletion",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "estimatedCost",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "recognitionProfit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "recognitionProfitPercentage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "f39969639d86a526c73a45310033b67a";

export default node;
